import React, { useEffect } from "react";

export function NursingBrochure() {
    useEffect(() => {
        window.location.href = "https://indd.adobe.com/view/d3efb8b2-0fa1-4423-8e9c-de6371b696d5";
    });
    return <></>;
}
